import { useTranslation } from "react-i18next";
import DataTable from "../../../../components/table/dataTable";
import Paginate from "../../../../components/pagination/paginate";
import { useState } from "react";
import Popup from "../../../../components/popups/popup";
import AddOffer from "./addOffer";
import EditIcon from "../../../../icons/editIcon";
import EditOffer from "./editOffer";
import BoardButton from "../../../../components/buttons/boardButton";
import { primaryColor } from "../../../../utils";
import SaleTagIcon from "../../../../icons/saleTagIcon";
import DeleteIcon from "../../../../icons/deleteIcon";
import "./style.css";
import EditInfo from "./editInfo";
const OffersAndPrices = () => {
  const { t } = useTranslation();
  const [editShipping, setEditShipping] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [editOffer, setEditOffer] = useState(false);

  const tableHead = [
    { header: t("shippingType"), accessorKey: "type" },
    { header: t("originalPrice"), accessorKey: "basePrice" },
    { header: t("pricePerExtraKilo"), accessorKey: "extraKiloPrice" },
    { header: t("maxWeight"), accessorKey: "maxWeight" },
    { header: t("actions"), accessorKey: "actions" },
  ];
  const shipmentData = [
    {
      type: "شحن محلي سريع",
      basePrice: "25 ريال",
      extraKiloPrice: "5 ريال",
      maxWeight: "30 كجم",
      actions: "",
    },
    {
      type: "شحن محلي عادي",
      basePrice: "15 ريال",
      extraKiloPrice: "3 ريال",
      maxWeight: "30 كجم",
      actions: "",
    },
    {
      type: "شحن دولي",
      basePrice: "100 ريال",
      extraKiloPrice: "20 ريال",
      maxWeight: "50 كجم",
      actions: "",
    },
  ];

  const tableData = shipmentData.map((d, i) => {
    const actions = (
      <span
        onClick={() => {
          setEditShipping(true);
        }}
        className="block mx-auto w-fit"
      >
        <EditIcon className="cursor-pointer" fill={primaryColor} />
      </span>
    );
    return {
      type: d.type,
      basePrice: d.basePrice,
      extraKiloPrice: d.extraKiloPrice,
      maxWeight: d.maxWeight,

      actions,
    };
  });
  const data = { last_page: 20 };
  const handlePagination = () => {};

  return (
    <main className="space-y-5 text-black dark:text-white">
      <div className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap">
        <h1 className="font-medium">{t("Offers And Prices")}</h1>

        <BoardButton onClick={() => setShowAdd(true)} primary bg>
          {t("addOffer")}
        </BoardButton>
      </div>

      {/* الكروت */}
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className="p-4 space-y-4 transition-colors bg-white dark:bg-gray-900 rounded-2xl"
          >
            <p className="flex items-center justify-between gap-4">
              <SaleTagIcon />
              <span className="p-1 rounded-lg text-[#11A849] bg-[#E6F4EF] dark:bg-green-900/40">
                {t("active")}
              </span>
            </p>
            <h3 className="font-bold">عرض {i === 0 ? "الصيف" : "العملاء الجدد"}</h3>
            <p className="text-mainGray dark:text-gray-400">
              {i === 0
                ? "خصم 20% على جميع الشحنات الدولية"
                : "خصم 10% على الشحنة الأولى"}
            </p>
            <div className="flex items-center justify-between gap-4">
              <p style={{ color: primaryColor }} className="text-2xl font-bold">
                {i === 0 ? "20%" : "10%"}
              </p>
              <p className="text-mainGray dark:text-gray-400">مايو 2025 - اغسطس 2025</p>
            </div>
            <div className="flex items-center justify-end gap-2">
              <span onClick={() => setEditOffer(true)}>
                <EditIcon fill={primaryColor} />
              </span>
              <span>
                <DeleteIcon />
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* جدول الأسعار */}
      <div className="min-w-full p-5 capitalize bg-white dark:bg-gray-900 rounded-2xl">
        <section className="flex border-b border-b-[#888888] pb-2 flex-wrap items-center justify-between">
          <div className="font-medium">{t("basicShippingRates")}</div>
        </section>
        <div className="min-w-full my-5 overflow-x-auto">
          <DataTable TableHead={tableHead} TableData={tableData} />
        </div>

        {/* النوافذ */}
        <Popup state={showAdd} setState={setShowAdd} header={t("addOffer")}>
          <AddOffer t={t} />
        </Popup>
        <Popup state={editOffer} setState={setEditOffer} header={t("editOffer")}>
          <EditOffer t={t} />
        </Popup>
        <Popup state={editShipping} setState={setEditShipping} header={t("editInfo")}>
          <EditInfo t={t} />
        </Popup>

        <Paginate handlePagination={handlePagination} data={data} />
      </div>
    </main>
  );
};

export default OffersAndPrices;
